import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';

import i18n from 'FRONTEND/utils/i18n';

const CalendarError = ({
  open,
  onClose,
  children,
  title,
  fullWidth,
}) => {
  const handleClose = () => {
    onClose();
    setIsOpen(false);
  };

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  return (
    <Dialog
      fullWidth={fullWidth}
      open={isOpen}
      onClose={() => handleClose()}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-error-dialog-title'>{title}</DialogTitle>
      <DialogContent>
        {
          children ||
            <Typography>
              {i18n._('You can’t delete or modify an availability when an active appointment is booked on it. Please edit your appointments before modifying the availability.')}
            </Typography>
        }
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose(false)} variant='contained' autoFocus>
          Fermer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CalendarError;
